<template v-if="applicationModule">
  <focus-page :title="applicationModule.module.name">
    <wo-typography v-wo-color.light v-wo-text.xl>
      <i18n :path="applicationModule.infoKey" tag="p">
        <po-email-link place="contact" :value="applicationModule.contact_email" label-key="general.contactUs"></po-email-link>
      </i18n>
    </wo-typography>
    <wo-spacer mod-xl />
    <wo-region v-wo-align:right>
      <po-promise-button label-key="general.action.returnToDashboard" @click="returnToDashboard" />
    </wo-region>
  </focus-page>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'

import { DASHBOARD } from '@/routes/general'
import { Entities } from '@/model/util'

import FocusPage from '@/components/layout/FocusPage'

export default {
  components: { FocusPage },
  props: {
    moduleId: String
  },
  computed: mapState({
    capabilities: state => state.identity.capabilities,
    applicationModule () {
      return this.capabilities && _.find(this.capabilities.modules, m => Entities.hasId(m, this.moduleId))
    }
  }),
  methods: {
    returnToDashboard () {
      this.$router.push({ name: DASHBOARD })
    }
  }
}
</script>
